type Image = {
    [key: string]: string;
}

const IMAGES: Image = {
    "close": require("./close.svg").default,
}

export default IMAGES